import React, { useEffect, useRef } from "react";
import {
    UserCheck,
    Calendar,
    Folder,
    DollarSign,
    Box,
    BarChart2,
} from "react-feather";

const features = [
    { icon: UserCheck, title: "Patient Management" },
    { icon: Calendar, title: "Appointment Scheduling" },
    { icon: Folder, title: "Electronic Medical Records" },
    { icon: DollarSign, title: "Billing & Finance" },
    { icon: Box, title: "Inventory Management" },
    { icon: BarChart2, title: "Reports & Analytics" },
];

const FeatureSection = () => {
    const scrollRef = useRef(null);

    useEffect(() => {
        const container = scrollRef.current;
        let scrollAmount = 0;

        const slide = () => {
            if (!container) return;

            scrollAmount += 0.5; // speed control

            if (scrollAmount >= container.scrollWidth / 2) {
                scrollAmount = 0;
            }

            container.scrollLeft = scrollAmount;
            requestAnimationFrame(slide);
        };

        requestAnimationFrame(slide);
    }, []);

    return (
        <section className="bg-white py-5">
            <div className="container">
                <div className="text-center mb-3" data-aos="zoom-in">
                    <h2 className="fw-bold fs-1">Our <span className="lanp-secondary-text">Features</span></h2>
                    <p className="text-muted mb-0">
                        Manage your healthcare system efficiently
                    </p>
                </div>
                <div
                    ref={scrollRef}
                    className="d-flex overflow-hidden"
                >
                    {[...features, ...features].map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div
                                key={index}
                                className="col-6 col-lg-2 flex-shrink-0 px-2"
                            >
                                <div className="bg-light rounded shadow-sm p-3 h-100 d-flex flex-column align-items-center justify-content-center text-center">
                                    <Icon size={30} className="mb-2 lanp-secondary-text bg-white p-1 rounded-circle" />
                                    <h6 className="fw-semibold mb-0 text-dark">{item.title}</h6>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FeatureSection;